$(document).ready(function() {
  $('div.service-product__label').on('click', function(e) {
    let selected_value = $(this).attr('data-size-option');
    $('tr#hire-option-empty').hide()
    $('input[name="hire-size-option"]').val(selected_value)
    $('tr.hire-option').each(function( index ) {
      if($( this ).attr('data-value') === selected_value){
        $( this ).show();
      } else {
        $( this ).hide();
      }
    });
  })


  // radio button selection
  $('label.card-radio').click(function(e){
    $(this).find('input[name=trailer-size]').prop('checked', true);
    e.stopPropagation();
    e.preventDefault();
  });

});